
  const audit = {
    path: "/audit",
    name: "audit",
    component: () => import(/* webpackChunkName: "audit" */ "@/components/audit/DataAudit.vue"),
    meta: { authorize: ['Administrator', 'Manager'] , requiresAuth: true }
  };

export default audit;
    